import { Component, Event, EventEmitter, h, Host, Prop } from "@stencil/core";
import { TableRowWithId } from "../table-interfaces";
import { FilterCriterion } from "../table-types";

@Component({
    tag: "uic-table-head-filter",
    styleUrl: "table-head-filter.scss",
    shadow: true
})
export class TableFilter {
    /** These are the items that are displayed in the filter list.
     * The items are automatically filtered for identical values */
    @Prop() readonly filterItems: [] = [];

    /** This is the name of the filter field used in the sort click event */
    @Prop() readonly field: string = "";

    /** callback function used to sort the column */
    @Prop() readonly customFilterCallback?: (filteredData: TableRowWithId[], selectedItems: []) => TableRowWithId[];

    /**determines whether empty and double values should be filtered*/
    @Prop() readonly filterEmptyAndDuplicateItems: boolean = false;

    /** When the confirm Button in the filter is clicked it emits the filtered items */
    @Event({
        eventName: "uicTableFilter",
        composed: true,
        cancelable: true,
        bubbles: true
    })
    filterEvent: EventEmitter;

    private onFilterChanged(event) {
        const fc: FilterCriterion = {
            selectedItems: event.detail,
            field: this.field,
            customFilterCallback: this.customFilterCallback
        };
        this.filterEvent.emit(fc);
    }

    private filterOutEmptyAndDublicateItems() {
        return [...new Set(this.filterItems.map((item) => item[this.field]).filter((item) => item !== "" && item !== undefined))];
    }

    render() {
        return (
            <Host onUicChange={(event) => this.onFilterChanged(event)}>
                <slot />
                &nbsp;
                <uic-filter
                    items={this.filterEmptyAndDuplicateItems ? this.filterOutEmptyAndDublicateItems() : this.filterItems}
                    bindLabel={this.field}
                    hoist
                    multiple
                >
                    <uic-icon-button slot='custom-trigger' icon='uic:filter'></uic-icon-button>
                </uic-filter>
            </Host>
        );
    }
}
